import React, { useContext } from 'react'
import { Card } from 'react-bootstrap'
import { GetUserContext } from '../Context/GetUserContext';
import AccountsPayable from '../Components/PageFinans/AccountsPayable';
import FinancialReport from '../Components/PageFinans/FinancialReport';
import './PageFinanceiro.css'
import CashPayment from '../Components/PageFinans/CashPayment';

const PageFinanceiro = () => {
    const { conjIdHome } = useContext(GetUserContext);

    return (
        <>
            <Card className='card-container card-fin-main'>
                <Card.Body className='card-content-body'>
                    {conjIdHome == 1 && (<AccountsPayable />)}
                    {conjIdHome == 2 && (<CashPayment />)}
                    {conjIdHome == 3 && (<FinancialReport />)}
                </Card.Body>
            </Card>
            <div></div>
        </>
    )
}

export default PageFinanceiro